module.exports = __webpack_public_path__ + "static/hero-f28963e9c467a485d737d605535ef31b.jpg";